/* eslint-disable no-nested-ternary */
import {
  Box,
  Container,
  AppBar,
  Toolbar,
  Typography,
  Button,
  Paper,
  Stack,
  Chip,
  TextField,
  InputAdornment,
  ToggleButton,
  ToggleButtonGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Skeleton,
  Link,
  MenuItem,
  FormControl,
  InputLabel,
  Select
} from '@material-ui/core';
import {
  Search as SearchIcon,
  Sync as SyncIcon,
  CloudDownload as DownloadIcon,
  Sms as SmsIcon,
  People as PeopleIcon
} from '@material-ui/icons';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { toast } from 'sonner';
import { useMembersContext } from '../../context/onoff_context';
import { useConstantsContext } from '../../context/constants_context';
import { StatusPill, fullName } from './StatusPill';
import { MemberDialog } from './MemberDialog';
import { SmsDialog } from './SmsDialog';

const provinceValue = (m) =>
  [m.province, m.area_desc, m.area_code].find((v) => v && String(v).trim()) ?? '';

const provinceMatch = (m, selected) => {
  const value = provinceValue(m);
  return Boolean(value) && value.trim().toLowerCase() === String(selected).trim().toLowerCase();
};

export default function OnOffDash() {
  const { members: all, loading, fetchMembers, provinces, fetchProvinces } = useMembersContext();
  const [province, setProvince] = useState('All');
  const { payCycles } = useConstantsContext();
  const currentMonth = sessionStorage.getItem('payCycleId');
  const today = new Date().toISOString().slice(0, 10);
  const monthAgo = new Date(Date.now() - 30 * 864e5).toISOString().slice(0, 10);
  // const [from, setFrom] = useState(monthAgo);
  // const [to, setTo] = useState(today);
  const [onOff, setOnOff] = useState('All');
  const [status, setStatus] = useState('All');
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState({});
  const [openMember, setOpenMember] = useState(null);
  const [smsTargets, setSmsTargets] = useState(null);
  const [begDate, setBegDate] = useState(currentMonth);
  const [endDate, setEndDate] = useState(currentMonth);

  const byOnOff = useMemo(
    () => (onOff === 'All' ? all : all.filter((m) => m.on_off === onOff)),
    [all, onOff]
  );

  const statuses = useMemo(() => {
    const countsMap = byOnOff.reduce((map, m) => {
      const key = m.status || 'Unspecified';
      return map.set(key, (map.get(key) ?? 0) + 1);
    }, new Map());

    return Array.from(countsMap.entries()).sort((a, b) => b[1] - a[1]);
  }, [byOnOff]);

  useEffect(() => setStatus('All'), [onOff]);

  const rows = useMemo(() => {
    const term = search.trim().toLowerCase();
    return byOnOff
      .filter((m) => status === 'All' || (m.status || 'Unspecified') === status)
      .filter((m) => province === 'All' || provinceMatch(m, province))
      .filter((m) =>
        !term
          ? true
          : [m.membername, m.initials, m.emp_no, m.station_description, m.area_desc, m.phone]
              .filter(Boolean)
              .some((v) => String(v).toLowerCase().includes(term))
      );
  }, [byOnOff, status, province, search]);

  const selectedMembers = rows.filter((m) => selected[m.id]);
  const allSelected = rows.length > 0 && rows.every((m) => selected[m.id]);
  const someSelected = selectedMembers.length > 0 && !allSelected;

  const syncMutation = {
    isPending: loading,
    mutate: async () => {
      try {
        console.log('beg date apa ', begDate);
        const n = await fetchMembers(begDate, endDate);
        toast.success(`${n} record(s) loaded.`);
      } catch (err) {
        toast.error(err.message);
      }
    }
  };

  useEffect(() => {
    fetchProvinces();
    syncMutation.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle = (id, checked) =>
    setSelected((prev) => {
      const next = { ...prev };
      if (checked) next[id] = true;
      else delete next[id];
      return next;
    });

  const toggleAll = (checked) => {
    if (checked) {
      const additions = rows.reduce((acc, m) => ({ ...acc, [m.id]: true }), {});
      setSelected((prev) => ({ ...prev, ...additions }));
      return;
    }

    const rowIds = new Set(rows.map((m) => m.id));
    setSelected((prev) =>
      Object.fromEntries(Object.entries(prev).filter(([id]) => !rowIds.has(id)))
    );
  };

  const exportCsv = () => {
    const header = [
      'Surname',
      'Initials',
      'Emp.No.',
      'Department',
      'Station Description',
      'Status',
      'On/Off',
      'DB Status',
      'Phone'
    ];
    const lines = rows.map((m) =>
      [
        m.membername,
        m.initials,
        m.emp_no,
        m.department,
        m.station_description,
        m.status,
        m.on_off,
        m.currentStatus,
        m.phone
      ]
        .map((v) => `"${String(v ?? '').replace(/"/g, '""')}"`)
        .join(',')
    );
    const blob = new Blob([[header.join(','), ...lines].join('\n')], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `members-${onOff.toLowerCase()}-${Date.now()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const counts = {
    on: all.filter((m) => m.on_off === 'On').length,
    off: all.filter((m) => m.on_off === 'Off').length
  };

  const statCards = [
    { label: 'Total records', value: all.length, tone: 'neutral', pick: 'All' },
    { label: 'ON pay', value: counts.on, tone: 'on', pick: 'On' },
    { label: 'OFF pay', value: counts.off, tone: 'off', pick: 'Off' }
  ];

  console.log('rows chaiwo ', rows);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static" color="primary" elevation={0}>
        <Toolbar sx={{ gap: 2 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6">Member ON/OFF Register</Typography>
            <Typography variant="caption" sx={{ opacity: 0.8 }}>
              ON and OFF pay administration, notices and member interactions
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
            gap: 2,
            mb: 3
          }}
        >
          {statCards.map((card) => (
            <Paper
              key={card.label}
              onClick={() => setOnOff(card.pick)}
              sx={{
                p: 2.5,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                border: 2,
                borderColor: onOff === card.pick ? 'primary.main' : 'transparent'
              }}
            >
              <Box>
                <Typography variant="body2" color="text.secondary">
                  {card.label}
                </Typography>
                <Typography variant="h4">{card.value}</Typography>
              </Box>
              <StatusPill tone={card.tone}>{card.label.split(' ')[0]}</StatusPill>
            </Paper>
          ))}
        </Box>

        <Paper sx={{ p: 2.5, mb: 3 }}>
          <Stack spacing={2.5}>
            <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
              <Typography variant="overline" color="text.secondary">
                Pay column
              </Typography>
              <ToggleButtonGroup
                exclusive
                size="small"
                color="primary"
                value={onOff}
                onChange={(_e, v) => v && setOnOff(v)}
              >
                <ToggleButton value="All">All records</ToggleButton>
                <ToggleButton value="On" sx={{ '&.Mui-selected': { color: 'success.main' } }}>
                  On pay
                </ToggleButton>
                <ToggleButton value="Off" sx={{ '&.Mui-selected': { color: 'warning.main' } }}>
                  Off pay
                </ToggleButton>
              </ToggleButtonGroup>
            </Stack>

            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              flexWrap="wrap"
              useFlexGap
              sx={{ borderTop: 1, borderColor: 'divider', pt: 2 }}
            >
              <Typography variant="overline" color="text.secondary" sx={{ mr: 1 }}>
                Status
              </Typography>
              <Chip
                label={`View all (${byOnOff.length})`}
                color={status === 'All' ? 'primary' : 'default'}
                variant={status === 'All' ? 'filled' : 'outlined'}
                onClick={() => setStatus('All')}
              />
              {statuses.map(([value, count]) => (
                <Chip
                  key={value}
                  label={`${value} (${count})`}
                  color={status === value ? 'primary' : 'default'}
                  variant={status === value ? 'filled' : 'outlined'}
                  onClick={() => setStatus(value)}
                  sx={{ maxWidth: 360 }}
                />
              ))}
            </Stack>

            <Stack
              direction={{ xs: 'column', md: 'row' }}
              spacing={1.5}
              sx={{ borderTop: 1, borderColor: 'divider', pt: 2 }}
            >
              <FormControl fullWidth>
                <InputLabel id="payCycleLbl">Pay Period</InputLabel>
                <Select
                  id="payCycleID"
                  value={begDate}
                  name="payCycleID"
                  fullWidth
                  size="small"
                  variant="outlined"
                  onChange={(e) => {
                    setBegDate(e.target.value);
                  }}
                >
                  <MenuItem key="" value="">
                    Not Selected
                  </MenuItem>
                  {payCycles.slice(0, 12).map((item) => (
                    <MenuItem key={item.payCycleId} value={item.payCycleId}>
                      {moment(item.payDate).format('YYYY-MM-DD')}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="payCycleLbl">Pay Period</InputLabel>
                <Select
                  id="payCycleID"
                  value={endDate}
                  name="payCycleID"
                  fullWidth
                  size="small"
                  variant="outlined"
                  onChange={(e) => {
                    setEndDate(e.target.value);
                  }}
                >
                  <MenuItem key="" value="">
                    Not Selected
                  </MenuItem>
                  {payCycles.slice(0, 12).map((item) => (
                    <MenuItem key={item.payCycleId} value={item.payCycleId}>
                      {moment(item.payDate).format('YYYY-MM-DD')}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* <TextField
                size="small"
                type="date"
                label="To"
                value={to}
                onChange={(e) => setTo(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 160 }}
              /> */}
              <Button
                variant="outlined"
                startIcon={<SyncIcon />}
                disabled={syncMutation.isPending}
                onClick={() => syncMutation.mutate()}
                sx={{ whiteSpace: 'nowrap', flexShrink: 0, px: 2 }}
              >
                Pull records
              </Button>
              <FormControl sx={{ minWidth: 200 }}>
                <InputLabel id="provinceLbl">Province</InputLabel>
                <Select
                  labelId="provinceLbl"
                  value={province}
                  label="Province"
                  size="small"
                  onChange={(e) => setProvince(e.target.value)}
                >
                  <MenuItem value="All">All provinces</MenuItem>
                  {provinces.map((p) => (
                    <MenuItem key={p} value={p}>
                      {p}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                size="small"
                fullWidth
                placeholder="Search name, employee number, station, area or phone"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
              <Button
                variant="outlined"
                startIcon={<DownloadIcon />}
                disabled={rows.length === 0}
                onClick={exportCsv}
                sx={{ whiteSpace: 'nowrap', flexShrink: 0, px: 2 }}
              >
                Export CSV
              </Button>
              <Button
                variant="outlined"
                startIcon={<SmsIcon />}
                disabled={selectedMembers.length === 0}
                onClick={() => setSmsTargets(selectedMembers)}
                sx={{ whiteSpace: 'nowrap', flexShrink: 0, px: 2 }}
              >
                SMS selected ({selectedMembers.length})
              </Button>
              <Button
                variant="contained"
                startIcon={<SmsIcon />}
                disabled={rows.length === 0}
                onClick={() => setSmsTargets(rows)}
                sx={{ whiteSpace: 'nowrap', flexShrink: 0, px: 2 }}
              >
                SMS all filtered ({rows.length})
              </Button>
            </Stack>
          </Stack>
        </Paper>

        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={allSelected}
                    indeterminate={someSelected}
                    onChange={(e) => toggleAll(e.target.checked)}
                    inputProps={{ 'aria-label': 'Select all filtered records' }}
                  />
                </TableCell>
                {['Member', 'Emp. No.', 'Station', 'Pay', 'Status', 'Area', 'Phone'].map((h) => (
                  <TableCell key={h} sx={{ fontWeight: 700 }}>
                    {h}
                  </TableCell>
                ))}
                <TableCell align="right" sx={{ fontWeight: 700 }}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                Array.from({ length: 6 }).map((_, i) => (
                  <TableRow key={i}>
                    <TableCell colSpan={9}>
                      <Skeleton height={28} />
                    </TableCell>
                  </TableRow>
                ))
              ) : rows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 8 }}>
                    <PeopleIcon color="disabled" fontSize="large" />
                    <Typography fontWeight={600} sx={{ mt: 1 }}>
                      No records to show
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Choose ON or OFF and pick dates and use “Pull records” to load members.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                rows.map((m) => (
                  <TableRow key={m.id} hover selected={Boolean(selected[m.id])}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={Boolean(selected[m.id])}
                        onChange={(e) => toggle(m.id, e.target.checked)}
                        inputProps={{ 'aria-label': `Select ${fullName(m)}` }}
                      />
                    </TableCell>
                    <TableCell>
                      <Link
                        component="button"
                        underline="hover"
                        fontWeight={600}
                        onClick={() => setOpenMember(m)}
                      >
                        {fullName(m)}
                      </Link>
                    </TableCell>
                    <TableCell>{m.emp_no}</TableCell>
                    <TableCell
                      sx={{
                        maxWidth: 240,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {m.station_description ?? '—'}
                    </TableCell>
                    <TableCell>
                      <StatusPill tone={m.on_off === 'On' ? 'on' : 'off'}>{m.on_off}</StatusPill>
                    </TableCell>
                    <TableCell
                      sx={{
                        maxWidth: 260,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {m.status || 'Unspecified'}
                    </TableCell>
                    <TableCell>{m.currentStatus ?? '—'}</TableCell>
                    <TableCell>{m.phone}</TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap', flexShrink: 0, px: 2 }}>
                      <Button size="small" onClick={() => setOpenMember(m)}>
                        Profile
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => setSmsTargets([m])}
                        sx={{ ml: 1 }}
                      >
                        SMS
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <MemberDialog
        member={openMember}
        onClose={() => setOpenMember(null)}
        onSendSms={(m) => setSmsTargets([m])}
      />
      <SmsDialog
        open={Boolean(smsTargets)}
        onClose={() => setSmsTargets(null)}
        recipients={smsTargets ?? []}
      />
    </Box>
  );
}
